module.exports = "img/flags/ST.0cf97a4.png";